export default {
  isQuotaAvailable: ({ isQuotaAvailable }: any) => isQuotaAvailable,
};
